// extracted by mini-css-extract-plugin
var _1 = "EmailReplyFormMobileMoreActions-moduledivider__qbGOo Divider-moduleDivider__dL3Vg";
export { _1 as "divider" }
